import Subsidaryaddhood from './subsidary_add_hood.vue';
import SubsidaryDetail from './subsidary-detail.vue';
import Newsubsidaryform from './new_subsidary_form.vue'
import SubsidariesDetailTablePanel from './subsidaries-detail-table-panel.vue';
export default{
  Subsidaryaddhood,
  Newsubsidaryform,
  SubsidariesDetailTablePanel,
  'subsidary-detail': SubsidaryDetail
}